import { render, staticRenderFns } from "./MaterialLocationDetail.vue?vue&type=template&id=170ee38f&scoped=true"
import script from "./MaterialLocationDetail.vue?vue&type=script&lang=js"
export * from "./MaterialLocationDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "170ee38f",
  null
  
)

export default component.exports